export function initPagination(container = document) {
  container.querySelectorAll('.pagination').forEach(pagination => {
    const buttons = Array.from(pagination.querySelectorAll('button'));

    function activatePage(button) {
      buttons.forEach(btn => {
        btn.classList.remove('active');
        btn.removeAttribute('aria-current');
      });
      button.classList.add('active');
      button.setAttribute('aria-current', 'page');
      // L'app gère le changement de contenu ici
    }

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (!button.disabled) {
          activatePage(button);
        }
      });

      button.addEventListener('keydown', (event) => {
        const index = buttons.indexOf(button);
        if (event.key === 'ArrowLeft' && index > 0) {
          buttons[index - 1].focus();
        } else if (event.key === 'ArrowRight' && index < buttons.length - 1) {
          buttons[index + 1].focus();
        } else if ((event.key === 'Enter' || event.key === ' ') && !button.disabled) {
          activatePage(button);
          event.preventDefault();
        }
      });
    });
  });
}